// Export backend modules
export {
  SecurityModule,
  SecurityInterceptor,
  SanitizeInterceptor,
  HelmetConfig,
  RolesGuard,
  Roles,
  ValidationPipe,
  LoggerMiddleware,

  ModernCsrfMiddleware,
  RateLimiterMiddleware,
  SecurityConfigService,
  ApiSecurityGuard,
  CorsMiddleware,
  AuditLogInterceptor,
  SqlInjectionGuard,
  ValidateInput,
  ApiVersion,
  ApiVersions,
  KeycloakGuard,
  SsrfProtectionGuard,
  SecurityMonitoringService,
  SessionSecurityService,
  SecretsManagerService,
  SecurityHealthController,
  MfaService
} from './backend';

// Export backend sanitizer with alias
export { sanitizeInput as backendSanitizeInput } from './backend/xssSanitizer';

// Export frontend modules
export {
  XssSanitizer,
  sanitizeInput,
  sanitizeRecursive,
  sanitizeUrl,
  xssSanitizer,
  CspConfig,
  cspConfig,
  SecureStorage,
  secureStorage,
  ContentSecurity,
  contentSecurity,
  SecurityHeaders,
  securityHeaders,
  SecurityConfig as FrontendSecurityConfig,
  securityConfig as frontendSecurityConfig,
  KeycloakClient,
  SecurityScanner
} from './frontend';

// Export crypto modules
export * from './crypto';

// Export utility modules
export * from './utils/config';
export * from './utils/logger';